module.exports = __webpack_public_path__ + "static/media/Rating Copy 3.20f90d8a.svg";